module.exports = __webpack_public_path__ + "img/chongya-1.f2b0f298.png";